import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  id: number;
  options?: Omit<
    UseMutationOptions<unknown, Error, {}, boolean>,
    'mutationKey' | 'mutationFn'
  >;
}

export const useDeleteReleaseRequest = ({ id, options }: RequestParams) => {
  const api = useApiInstance()

  return useMutation<unknown, Error, {}, boolean>(
    [Entities.Release, 'delete'],
    async () => {
      const { data } = await api.v1AdminReleasesReleaseIdDelete(id)
      return data
    },
    {
      ...options,
    },
  )
}
